import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader } from '../components/ui/Card';
import { brandConfig } from '../config';
import { useTheme } from '../theme/ThemeProvider';

interface LoginLayoutProps {
  children: React.ReactNode;
  belowCard?: React.ReactNode;
}

export default function LoginLayout({ children, belowCard }: LoginLayoutProps) {
  const { resolvedMode } = useTheme();
  const logoUrl = resolvedMode === 'dark' ? brandConfig.logoUrlDark : brandConfig.logoUrl;

  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-6 bg-cover bg-center bg-no-repeat p-4 sm:p-6 bg-background"
      style={{
        backgroundImage: brandConfig.backgroundUrl
          ? `linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)), url(${brandConfig.backgroundUrl})`
          : undefined
      }}
    >
      <Card className="w-full max-w-md rounded-2xl border-border/60 bg-card/95 shadow-xl backdrop-blur-sm">
        <CardHeader className="pb-2 pt-6 sm:pb-4 sm:pt-8">
          <Link
            to="/"
            className="w-full h-auto block focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 rounded-lg"
          >
            <img src={logoUrl} alt={brandConfig.name} className="w-full h-auto object-contain" />
          </Link>
        </CardHeader>
        <CardContent className="px-6 pb-6 pt-0 sm:px-8 sm:pb-8 text-foreground">
          {children}
        </CardContent>
      </Card>
      {belowCard}
    </div>
  );
}
